export default "__VITE_ASSET__DEkwmHXY__"